module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [_c('legend', [_vm._v("Activate Rubric")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Pager-number")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.number),
      expression: "form.number",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2097151",
      "placeholder": "0 - 2097151"
    },
    domProps: {
      "value": (_vm.form.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.number = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Transmitter Groups")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.transmittergroups,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.transmittergroups),
      callback: function($$v) {
        _vm.form.transmittergroups = $$v
      },
      expression: "form.transmittergroups"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/rubrics"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Rubrics")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23ff2173"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rubric/Activation.vue
// module id = 611
// module chunks = 1